type AiChatAccount = {
  systemRole?: string | null;
  superAdmin?: unknown;
};

/**
 * Mirrors the server's chat gates. A Lime admin impersonating a tenant gets the
 * chat on any tenant (the server skips the tenant flag for impersonated
 * sessions); `superAdmin` is set only once `/client` has confirmed the actor is
 * an admin. Otherwise the caller must be Lime staff on a tenant that has been
 * switched on, so a salon's own staff never see it.
 */
export function canUseAiChat(
  accountInfo: AiChatAccount | null | undefined,
  tenantHasAiChat: boolean,
): boolean {
  if (accountInfo?.superAdmin) {
    return true;
  }

  const isLimeStaff = ["admin", "salesman"].includes(
    accountInfo?.systemRole ?? "",
  );
  return isLimeStaff && tenantHasAiChat;
}
